export default {
  components: {},
  props: {
    componentData: { // 定制
      type: Object,
      default: () => ({})
    },
    selectRowData: { // 标准
      type: Array,
      default: () => ([])
    },
    objTabActionDialogConfig: { // 标准
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    componentData: {
      handler(newObj, oldObj) {
        console.log(newObj)
        this.isOrderInvoice = this.$route.params.customizedModuleName == 'ORDERMANAGER'
        const { tids } = newObj
        if (this.isOrderInvoice && tids.length) {
          const { email, phone, receiver, receiverAddress } = tids[0].receiverInfo || {}
          this.formConfig2.formValue = {
            RECEIVER: receiver,
            RECEIVER_ADDRESS: receiverAddress,
            PHONE: phone,
            EMAIL: email
          }
          this.TID = tids.map(i => i.tid).join('，')
          this.selectedTid = tids
        }
      },
      deep: true,
      immediate: true
    },
    changeType: {
      handler(newObj) {
        newObj != undefined && this.initData()
      }
    }
  },
  computed: {},
  data() {
    const validatePhoneNumber = (rule, value, callback) => {
      const pNumver = this.formConfig2.formValue.PHONE;
      if (/^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/.test(pNumver)) {
        return callback();
      }
      return callback(new Error(t('手机号格式不正确!')));
    };
    return {
      isChangeInvoice: false, // 是否是发票-【换票】
      isOrderInvoice: false, // 是否是零售-【申请发票】
      TID: '', // 平台单号
      selectedTid: [], // 选中的平台单号
      changeType: '1', // 换票类型
      changInvoiceOptions: [
        { label: t('换纸质'), value: '1' },
        { label: t('换专票'), value: '2' },
        { label: t('换抬头'), value: '3' },
      ],
      btnConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'right', // 按钮位置 (right , center , left)
        buttons: [
          {
            type: '', // 按钮类型
            text: t('取消'),
            size: 'small', // 按钮大小
            disabled: false, // 按钮禁用控制
            btnclick: () => {
              this.close();
            } // 按钮点击事件
          },
          {
            type: 'primary', // 按钮类型
            text: t('保存'),
            size: 'small', // 按钮大小
            disabled: false, // 按钮禁用控制
            btnclick: () => {
              this.save();
            } // 按钮点击事件
          }
        ]
      },
      formConfig: {
        formData: [
          {
            style: 'radio',
            label: t('发票种类'), // 发票种类
            value: 'INVOICE_KIND',
            width: '12',
            options: [
              {
                label: t('电子发票'),
                value: '1'
              },
              {
                label: t('纸质发票'),
                value: '0'
              },
            ],
            radioChange: () => {
              this.radioChange(this.formConfig, 'INVOICE_KIND')
            }
          },
          {
            style: 'radio',
            label: t('发票类型'), // 发票类型
            value: 'INVOICE_TYPE',
            width: '12',
            options: [
              // radio选项
              {
                label: t('普票'),
                value: '0'
              },
              {
                label: t('专票'),
                value: '1'
              },
            ],
            radioChange: () => {
              this.radioChange(this.formConfig, 'INVOICE_TYPE')
            }
          },
          {
            style: 'radio',
            label: t('抬头类型'),
            value: 'HEADER_TYPE',
            width: '24',
            options: [
              // radio选项
              {
                label: t('个人'),
                value: '0'
              },
              {
                label: t('企业'),
                value: '1'
              },
            ],
            radioChange: () => {
              this.radioChange(this.formConfig, 'HEADER_TYPE')
            }
          },
          {
            style: 'input',
            label: t('发票抬头'),
            value: 'INVOICE_HEADER',
            width: '8'
          },
          /* {
            style: 'input',
            label: t('开票金额'),
            value: 'INVOICE_AMOUNT',
            regx: /^\d*\.{0,1}\d{0,6}$/,
            width: '8'
          }, */
          {
            style: 'input',
            label: t('地址'),
            value: 'UNIT_ADDRESS',
            width: '8'
          },
          {
            style: 'input',
            label: t('纳税人识别号'),
            value: 'TAXPAYER_NO',
            width: '8'
          },
          {
            style: 'input',
            label: t('电话号码'),
            value: 'UNIT_MOBILE',
            width: '8'
          },
          {
            style: 'input',
            label: t('开户银行'),
            value: 'OPENING_BANK',
          },
          {
            style: 'input',
            label: t('银行账号'),
            value: 'BANK_ACCOUNT',
            width: '8'
          },
          {
            style: 'input',
            label: t('发票备注'),
            value: 'INVOICE_REMARK',
            width: '24'
          }
        ],
        formValue: {
          // 存储表单得所有值
          INVOICE_KIND: '1', // 发票种类
          INVOICE_TYPE: '0', // 发票类型
          HEADER_TYPE: '0', // 抬头类型
          INVOICE_HEADER: '', // 发票抬头
          // INVOICE_AMOUNT: '', // 开票金额
          UNIT_ADDRESS: '', // 地址
          UNIT_MOBILE: '', // 电话号码
          TAXPAYER_NO: '', // 纳税人识别号
          OPENING_BANK: '', // 开户银行
          BANK_ACCOUNT: '', // 银行账号
          INVOICE_REMARK: '', // 发票备注
        },
        ruleValidate: {
          INVOICE_KIND: [{ required: true }],
          INVOICE_TYPE: [{ required: true }],
          HEADER_TYPE: [{ required: true }],
          INVOICE_HEADER: [{ required: true }],
          // INVOICE_AMOUNT: [{ required: true }],
          TAXPAYER_NO: [{ required: false }],
          UNIT_ADDRESS: [{ required: false }],
          UNIT_MOBILE: [{ required: false }],
          OPENING_BANK: [{ required: false }],
          BANK_ACCOUNT: [{ required: false }],
        },
      },
      formConfig2: {
        formValue: {
          // 存储表单得所有值
          RECEIVER: '', // 收票人
          RECEIVER_ADDRESS: '', // 收票人地址
          PHONE: '', // 收货人手机
          EMAIL: '', // 邮箱
        },
        formData: [
          {
            style: 'input',
            label: t('收票人'), // 收票人
            value: 'RECEIVER',
            width: '8'
          },
          {
            style: 'input',
            label: t('收票人地址'), // 收票人地址
            value: 'RECEIVER_ADDRESS',
            width: '8'
          },
          {
            style: 'input',
            label: t('收货人手机'), // 收货人手机
            value: 'PHONE',
            width: '8'
          },
          {
            style: 'input',
            label: t('邮箱'), // 邮箱
            value: 'EMAIL',
            width: '8'
          }
        ],
        // 不做校验，数据可能是加密数据
        /* ruleValidate: {
          PHONE: [{ validator: validatePhoneNumber, message: '', trigger: 'blur' }],
          EMAIL: [{ type: 'email', message: '', trigger: 'blur' }]
        } */
      },
      formConfig3: {
        formData: [
          {
            style: 'radio',
            label: t('发票种类'), // 发票种类
            value: 'INVOICE_KIND',
            width: '12',
            options: [
              {
                label: t('电子发票'), // 电子发票
                value: '1'
              },
              {
                label: t('纸质发票'), // 纸质发票
                value: '0'
              },
            ],
            radioChange: () => {
              this.radioChange(this.formConfig3, 'INVOICE_KIND')
            }
          },
          {
            style: 'radio',
            label: t('发票类型'), // 发票类型
            value: 'INVOICE_TYPE',
            width: '12',
            options: [
              // radio选项
              {
                label: t('普票'), // 普票
                value: '0'
              },
              {
                label: t('专票'), // 专票
                value: '1'
              },
            ],
            radioChange: () => {
              this.radioChange(this.formConfig3, 'INVOICE_TYPE')
            }
          },
          {
            style: 'radio',
            label: t('抬头类型'), // 抬头类型
            value: 'HEADER_TYPE',
            width: '24',
            options: [
              // radio选项
              {
                label: t('个人'), // 个人
                value: '0'
              },
              {
                label: t('企业'), // 企业
                value: '1'
              },
            ],
            radioChange: () => {
              this.radioChange(this.formConfig3, 'HEADER_TYPE')
            }
          },
          {
            style: 'input',
            label: t('发票抬头'), // 发票抬头
            value: 'INVOICE_HEADER',
            width: '8'
          },
          /* {
            style: 'input',
            label: t('开票金额'), // 开票金额
            value: 'INVOICE_AMOUNT',
            regx: /^\d*\.{0,1}\d{0,4}$/,
            width: '8'
          }, */
          {
            style: 'input',
            label: t('地址'), // 地址
            value: 'UNIT_ADDRESS',
            width: '8'
          },
          {
            style: 'input',
            label: t('纳税人识别号'), // 纳税人识别号
            value: 'TAXPAYER_NO',
            width: '8'
          },
          {
            style: 'input',
            label: t('电话号码'), // 电话号码
            value: 'UNIT_MOBILE',
            width: '8'
          },
          {
            style: 'input',
            label: t('开户银行'), // 开户银行
            value: 'OPENING_BANK',
            width: '8'
          },
          {
            style: 'input',
            label: t('银行账号'), // 银行账号
            value: 'BANK_ACCOUNT',
            width: '8'
          },
          {
            style: 'input',
            label: t('发票备注'), // 发票备注
            value: 'INVOICE_REMARK',
            width: '24'
          }
        ],
        formValue: {
          // 存储表单得所有值
          INVOICE_KIND: '1', // 发票种类
          INVOICE_TYPE: '0', // 发票类型
          HEADER_TYPE: '0', // 抬头类型
          INVOICE_HEADER: '', // 发票抬头
          // INVOICE_AMOUNT: '', // 开票金额
          UNIT_ADDRESS: '', // 地址
          UNIT_MOBILE: '', // 电话号码
          TAXPAYER_NO: '', // 纳税人识别号
          OPENING_BANK: '', // 开户银行
          BANK_ACCOUNT: '', // 银行账号
          INVOICE_REMARK: '', // 发票备注
        },
        ruleValidate: {
          INVOICE_KIND: [{ required: true }],
          INVOICE_TYPE: [{ required: true }],
          HEADER_TYPE: [{ required: true }],
          INVOICE_HEADER: [{ required: true }],
          // INVOICE_AMOUNT: [{ required: true }],
          TAXPAYER_NO: [{ required: false }],
          UNIT_ADDRESS: [{ required: false }],
          UNIT_MOBILE: [{ required: false }],
          OPENING_BANK: [{ required: false }],
          BANK_ACCOUNT: [{ required: false }],
        },
      },
      formConfig4: {
        formData: [
          {
            style: 'input',
            label: t('平台单号'), // 平台单号
            value: 'TID',
            width: '10',
            placeholder: t('输入平台单号后请回车'),
            inputenter: () => {
              this.checkParam()
            }, // 表单回车事件
          },
        ],
        formValue: {
          TID: ''
        }
      }
    };
  },
  mounted() {
    const { webname } = this.objTabActionDialogConfig
    this.isChangeInvoice = webname == 'CHANGE_TICKETS'
    // 发票-【新增】
    if (this.isChangeInvoice) {
      if (!this.selectRowData.length) {
        $fcError(t('请选择需要申请换票的单据记录！'))
        this.$emit('closeActionDialog')
        return
      }
      if (this.selectRowData.length != 1) {
        $fcError(t('换票的单据只能选择一条订单发票！'))
        this.$emit('closeActionDialog')
        return
      }
      // 【取消状态】=已取消、【冻结状态】=已冻结 不允许换票
      const { CANCEL_STATUS, FREEZE_STATUS } = this.selectRowData[0]
      if ( CANCEL_STATUS.val == t('已取消')) {
        $fcError(t('选择的订单已经取消，不能申请换票！'))
        this.$emit('closeActionDialog')
        return
      }
      if ( FREEZE_STATUS.val == t('已冻结')) {
        $fcError(t('选择的订单已经冻结，不能申请换票！'))
        this.$emit('closeActionDialog')
        return
      }
      this.TID = this.selectRowData[0].TID.val
      this.initData()
    }
    this.radioChange(this.formConfig, 'INVOICE_KIND')
    this.$nextTick(() => {
      $('.ark-modal-wrap .ark-modal').attr('style', 'width: 900px')
      $('.ark-modal-wrap .ark-modal .ark-modal-content').attr('style', 'width: 900px')
    })
  },
  methods: {
    initData() {
      const handler = (formConfig) => {
        Object.keys(formConfig.formValue).forEach(key => {
          let val = (this.selectRowData[0][key] && this.selectRowData[0][key].val) || ''
          switch (key) {
            case 'INVOICE_TYPE':
              val = val == t('专票') ? '1' : '0'
              break;
            case 'INVOICE_KIND':
              val = val == t('电子') ? '1' : '0'
              break;
            case 'HEADER_TYPE':
              val = val == t('个人') ? '0' : '1'
              break;
            default:
              break;
          }
          const { handleFields } = this.getValidateInfo(formConfig, key)
          formConfig.ruleValidate = this.setRules(formConfig.ruleValidate, handleFields, true);
          formConfig.formValue[key] = val
        })
      }
      handler(this.formConfig)
      handler(this.formConfig3)
      // 原发票信息
      this.formConfig.formData.forEach(i => {
        const FILEDS = ['INVOICE_TYPE', 'INVOICE_KIND', 'HEADER_TYPE']
        FILEDS.includes(i.value) && (i.options.forEach(item => item.disabled = true))
        i.disabled = true
      })

      /**
       * 修改发票信息
       * 如果选择换票类型为：换纸质，都不可编辑，发票种类默认“纸质发票”；
       * 如果选择换票类型为专票，开户行、银行账户、地址、电话必填，发票类型默认“专票”且不能修改，抬头类型默认“企业”且不能修改；
       * 如果选择换抬头，只能修改开票信息；
       */
      this.formConfig3.formData.forEach(i => {
        let FILEDS = []
        switch (this.changeType) {
          case '1': // 换纸质
            this.formConfig3.formValue.INVOICE_KIND = '0'
            i.options && i.options.forEach(item => item.disabled = true)
            i.disabled = true
            break;
          case '2': // 换专票
            i.options && i.options.forEach(item => item.disabled = false)
            i.disabled = false
            FILEDS = ['INVOICE_TYPE', 'HEADER_TYPE']
            FILEDS.includes(i.value) && i.options.forEach(item => item.disabled = true)
            this.formConfig3.formValue.INVOICE_TYPE = '1'
            this.formConfig3.formValue.HEADER_TYPE = '1'
            this.radioChange(this.formConfig3, 'INVOICE_KIND')
            break;
          case '3': // 换抬头
            i.options && i.options.forEach(item => item.disabled = true)
            i.disabled = false
            break;
          default:
            break;
        }
      })
      Object.keys(this.formConfig2.formValue).forEach(key => {
        let val = (this.selectRowData[0][key] && this.selectRowData[0][key].val) || ''
        this.formConfig2.formValue[key] = val
      })
    },
    /**
     * 表单单选 - 联动字段的默认值、必填校验，及是否可编辑
     * @param {*} formConfig
     * @param {*} field
     */
    radioChange(formConfig, field) {
      const { isRequired, handleFields } = this.getValidateInfo(formConfig, field)
      formConfig.ruleValidate = this.setRules(formConfig.ruleValidate, handleFields, isRequired);
      switch (field) {
        case 'INVOICE_KIND': // 发票种类
          // 发票种类选“电子”，发票类型只能选“普票”，发票种类选“纸质”，发票类型只能选“专票”
          const { INVOICE_KIND } = formConfig.formValue
          formConfig.formValue.INVOICE_TYPE = INVOICE_KIND == '1' ? '0' : '1'
          this.queryForm(formConfig, 'INVOICE_TYPE').options.forEach(item => item.disabled = true)
          this.radioChange(formConfig, 'INVOICE_TYPE')
          break;
        case 'INVOICE_TYPE': // 发票类型
          // 发票类型为“专票”，抬头类型默认“企业”且不可修改
          const { INVOICE_TYPE } = formConfig.formValue
          if (INVOICE_TYPE == '1') {
            formConfig.formValue.HEADER_TYPE = '1'
            this.radioChange(formConfig, 'HEADER_TYPE')
          }
          this.queryForm(formConfig, 'HEADER_TYPE').options.forEach(item => item.disabled = INVOICE_TYPE == '1')
          break;
        default:
          break;
      }
    },
    /**
     * 字段校验处理
     * @param {*} rules ruleValidate
     * @param {*} fields 待处理字段
     * @param {*} isRequired 是否必填
     * @returns
     */
    setRules(rules, fields, isRequired) {
      return Object.fromEntries(
        Object.entries(rules)
          .map(([key, value]) => {
            fields.includes(key) && (value[0].required = isRequired);
            return [key, value];
          })
      );
    },
    // 必填项 - 字段联动必填项处理
    getValidateInfo(formConfig, filedName) {
      const val = formConfig.formValue[filedName]
      let isRequired = false
      let handleFields = []
      switch (filedName) {
        case 'HEADER_TYPE':
          isRequired = val == '1'
          handleFields = ['TAXPAYER_NO'];
          break;
        case 'INVOICE_TYPE':
          isRequired = val == '1'
          handleFields = ['UNIT_ADDRESS', 'UNIT_MOBILE', 'OPENING_BANK', 'BANK_ACCOUNT'];
          break;
        default:
          break;
      }
      return { isRequired, handleFields }
    },
    // 平台单号校验
    async checkParam() {
      if (this.selectedTid.length == 20 ) {
        $fcError(t('平台单号最多可添加20条！'))
        return
      }
      const tid = this.formConfig4.formValue.TID
      const isExist = this.selectedTid.some(i => i.tid == tid)
      if (isExist) return $fcError(t('该平台单号已添加！'))
      const { data: { code, data, message }} = await this.service.financeCenter.checkParam({ tid })
      if (code == 0) {
        if (data.receiverInfo) {
          const { email, phone, receiver, receiverAddress } = data.receiverInfo
          this.formConfig2.formValue = {
            RECEIVER: receiver,
            RECEIVER_ADDRESS: receiverAddress,
            PHONE: phone,
            EMAIL: email
          }
        }
        this.selectedTid.push(data)
        this.formConfig4.formValue.TID = ''
        return
      }
      $fcError(message)
    },
    // 移除选中的平台单号
    handleClose(event, name) {
      this.selectedTid = this.selectedTid.filter(i => i.tid != name)
    },
    // 保存
    save() {
      /* =========== 保存校验 start =========== */
      const isEmptyForTid = this.isChangeInvoice ? !this.TID : !this.selectedTid.length
      const validFormConfig = this.isChangeInvoice ? this.formConfig3 : this.formConfig
      const result1 = this.getValidateInfo(validFormConfig, 'HEADER_TYPE')
      const result2 = this.getValidateInfo(validFormConfig, 'INVOICE_TYPE')
      let valueArr = ['INVOICE_HEADER'];
      result1.isRequired && (valueArr = [...valueArr, ...result1.handleFields])
      result2.isRequired && (valueArr = [...valueArr, ...result2.handleFields])
      let mes = $utils.validatorNotEmpty(validFormConfig, valueArr);
      if (mes !== '') {
        isEmptyForTid && (mes = `${t('平台单号')}，${mes}`)
        this.$message.error(mes);
        return;
      } else if (isEmptyForTid) {
        this.$message.error(t('平台单号不能为空！'));
        return;
      }

      let actionMethod = ''
      let params = {}
      if (this.isChangeInvoice) {
        actionMethod = 'changeInvoice'
        const { ID, TID } = this.selectRowData[0]
        params = {
          ID: ID.val,
          TID: TID.val,
          changeType: this.changeType,
          ...this.formConfig3.formValue,
          ...this.formConfig2.formValue,
        }
      } else {
        actionMethod = 'saveApplyInvoice'
        const paylod = {
          TIDS: this.selectedTid,
          ...this.formConfig.formValue,
          ...this.formConfig2.formValue,
        }
        for (let key in paylod) {
          params[key.toLocaleLowerCase()] = paylod[key]
        }
        params.mobile = params.unit_mobile
        params.invoice_address = params.unit_address
        params.receiver_phone = params.phone
        delete params.unit_mobile
        delete params.unit_address
        delete params.phone
      }
      this.service.financeCenter[actionMethod](params).then((res) => {
        if (res.data.code === 0) {
          this.close();
          this.isChangeInvoice && this.$parent.$parent.$parent.getQueryList();
          this.isOrderInvoice && this.$parent.$parent.$parent.getData();
          this.$Message.success(res.data.message);
        } else {
          $fcError(res.data.message || t('失败！'));
        }
      });
    },
    close() {
      this.objTabActionDialogConfig.webname
        ? this.$emit('closeActionDialog')
        : this.$parent.$parent.closeConfirm();
    },
    queryForm(formConfig, field) {
      return formConfig.formData.find((item) => item.colname == field || item.value == field);
    },
  }
};
